<template>
  <!-- 上游机构费用记录 -->
  <div>
    <tabs ref="tabs" :columns="columns" :brokerageType="brokerageType" :getlistUrl="getlistUrl" @changeTabsBtn="changeTabsBtn"
      @exportForm="$emit('exportForm')"></tabs>
  </div>
</template>
<script>
import tabs from "./tabs.vue";
import filter from "@/api/filter";
import { mapState } from "vuex";

export default {
  components: {
    tabs,
  },
  data() {
    return {
      columns: [
        {
          title: "保单号",
          align: "center",
          key: "policyNo",
          minWidth: 200,
          fixed: "left",
          tooltip: true,
        },
        {
          title: "所属对账单",
          align: "center",
          slot: "checkName",
          minWidth: 200,
          tooltip: true,
        },
        {
          title: "上游结算状态",
          align: "center",
          key: "settlementStatus",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "对账状态",
          align: "center",
          slot: "reconciliationStatusDesc",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "对账日期",
          align: "center",
          key: "checkDate",
          minWidth: 140,
          tooltip: true,
          render(h, params) {
            if(params.row.checkDate){
              const value = filter.filterTime(params.row.checkDate, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: "供应商",
          align: "center",
          key: "supplier",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "保险公司",
          align: "center",
          key: "companyName",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "保险产品",
          align: "center",
          key: "productName",
          minWidth: 260,
          tooltip: true,
        },
        {
          title: "险种名称",
          align: "center",
          key: "productTypeName",
          minWidth: 260,
          tooltip: true,
        },
        {
          title: "最新状态",
          align: "center",
          key: "policyStatus",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "承保日期",
          align: "center",
          key: "insureTime",
          minWidth: 120,
          tooltip: true,
          render(h, params) {
            if(params.row.insureTime){
              const value = filter.filterTime(params.row.insureTime, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: "回执回销日期",
          align: "center",
          key: "receiptDate",
          minWidth: 120,
          tooltip: true,
          render(h, params) {
            if(params.row.receiptDate){
              const value = filter.filterTime(params.row.receiptDate, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: "回访日期",
          align: "center",
          key: "revisitDate",
          minWidth: 120,
          tooltip: true,
          render(h, params) {
            if(params.row.revisitDate){
              const value = filter.filterTime(params.row.revisitDate, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: "犹豫止期",
          align: "center",
          key: "hesitateDate",
          minWidth: 120,
          tooltip: true,
          render(h, params) {
            if(params.row.hesitateDate){
              const value = filter.filterTime(params.row.hesitateDate, "YYYY-MM-DD");
              return <span>{value}</span>;
            }
          },
        },
        {
          title: "保障期",
          align: "center",
          key: "guaranteeValueDesc",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "交费期",
          align: "center",
          key: "payValueDesc",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "交费期次",
          align: "center",
          key: "commissionPeriods",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "保费",
          align: "center",
          minWidth: 100,
          tooltip: true,
          render(h, params) {
            if(params.row.reviseFee){
              return <div>
                <span>{params.row.fee}</span>
                <span>(已强平)</span>
                </div>
  
            }else{
              return <span>{params.row.fee}</span>;
            }
          },
        },
        {
          title: "上游结算保费",
          align: "center",
          key: "supplierFee",
          minWidth: 100,
        },
        {
          title: "费用类型",
          align: "center",
          minWidth: 150,
          slot:"commissionType",
        },
        {
          title: "费用归属",
          align: "center",
          key: "owerName",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "费率",
          align: "center",
          minWidth: 100,
          tooltip: true,
          render(h, params) {
            return <span>{params.row.commission || '-'}</span>;
          },
        },
        {
          title: "上游结算费率",
          align: "center",
          key: "supplierCommission",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "费用",
          align: "center",
          key: "commissionPrice",
          minWidth: 150,
          tooltip: true,
          render(h, params) {
            const commissionPrice = params.row.commissionPrice;
            const deductType = params.row.deductType;
            let msg = '';
            if (deductType == 1) {
              msg = '退保';
            }else if (deductType == 2) {
              msg = '部分退保';
            }else if (deductType == 3) {
              msg = '退现价';
            } else if (deductType == 4) {
              msg = params.row.deductMsg;
            }
            let isDeduct = params.row.isDeduct;
            if (isDeduct == '1') {
              if(params.row.reviseCommission){
                return (
                <div style="display:flex; align-items: center; justify-content: center;">
                  <span>{commissionPrice ? commissionPrice : '-'}</span>
                  <Tooltip trigger="hover" placement="top-end" transfer={true}>
                    <span style="height:20px; width:34px; font-size: 12px; border: 1px solid #ffcf8e; background: #fff3e3; color: #ff7f00; margin-left: 5px; padding: 2px 2px; cursor: pointer;">
                      扣款
                    </span>
                    <div slot="content">
                      <p>{msg}</p>
                    </div>
                  </Tooltip>
                  <span>(已强平)</span>
                </div>
              );
              }else{
                return (
                <div style="display:flex; align-items: center; justify-content: center;">
                  <span>{commissionPrice ? commissionPrice : '-'}</span>
                  <Tooltip trigger="hover" placement="top-end" transfer={true}>
                    <span style="height:20px; width:34px; font-size: 12px; border: 1px solid #ffcf8e; background: #fff3e3; color: #ff7f00; margin-left: 5px; padding: 2px 2px; cursor: pointer;">
                      扣款
                    </span>
                    <div slot="content">
                      <p>{msg}</p>
                    </div>
                  </Tooltip>
                </div>
              );
              }
                
            } else {
              if(params.row.reviseCommission){
                return <span>{commissionPrice ? commissionPrice : '-'}（已强平）</span>;
              }else{
                return <span>{commissionPrice ? commissionPrice : '-'}</span>;
              }
              
            }
            
          }
        },
        {
          title: "上游结算费用",
          align: "center",
          key: "supplierCommissionPrice",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "投保人",
          align: "center",
          key: "holderName",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "出单业务员",
          align: "center",
          key: "salesmanName",
          minWidth: 120,
          tooltip: true,
        },
        {
          title: "出单团队",
          align: "center",
          minWidth: 160,
          render(h, params) {
            if (!params.row.groupName) {
              return h("div", {}, "-");
            } else {
              return h("div", {}, params.row.groupName);
            }
          },
        },
        {
          title: "出单机构",
          align: "center",
          key: "orgName",
          minWidth: 200,
        },
        {
          title: "已回款？",
          key: "receivableStatus",
          width: 100,
          align: "center",
        },
        {
          key: "payStatus",
          width: 100,
          align: "center",
          renderHeader: (h, params) => {
            return (
              <Tooltip
                trigger="hover"
                content="content"
                transfer={true}
              >
                <span>已付款</span>
                <span class="tip-icon">?</span>
                <div slot="content">
                  <span>代收保费是否已对上游付款</span>
                </div>
              </Tooltip>
            );
          }
        },
        {
          title: "核收人",
          align: "center",
          key: "reviewer",
          minWidth: 120,

        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 100,
          fixed: "right",
          cur: false,
        },
      ],
      brokerageType: 1,
      getlistUrl: "/buz/commissionReconciliation/policy/result",
    };
  },
  created() {
    if (this.userInfo.levelCode == "10001") {
      this.columns.forEach((el) => {
        if (el.title == "操作") {
          el.cur = false;
        }
      });
    } else {
      this.columns.forEach((el) => {
        if (el.title == "操作") {
          el.cur = true;
        }
      });
    }
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    changeTabsBtn(v) {
      this.$emit('changeTabsBtn', v)
    }
  },
};
</script>
<style lang="scss" scoped>
/deep/.tip-icon {
    border: 1px solid #000 !important;
    color: #000 !important;
  }
</style>